export default __webpack_public_path__ + "static/expressive-glass-teal-e1b53cf9bdf2a4a249726cb5578140ad.gif";